import { useMemo } from "react";
import { getMimeTypeMetadataRender } from "../utils/mimeTypes";

export function useMimeTypeMetadataRender(mimeType: string) {
    const result = useMemo(() => getMimeTypeMetadataRender(mimeType), [mimeType]);
    return result;
}
